import DateRange from "@mapmycustomers/shared/types/range/DateRange";
import formatISODate from "@mapmycustomers/shared/util/formatters/formatISODate";

import IsoDateRange from "../types/IsoDateRange";

const toIsoDateRange = (range: DateRange): IsoDateRange => [
  formatISODate(range.startDate),
  formatISODate(range.endDate),
];

export default toIsoDateRange;
